<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="query['owner.id']" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
        <vxe-input v-model="query['no']" placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" clearable linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="130"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="150"/>
        <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
        <vxe-column field="submissionAdvice.operator" title="business.label.submissionAdviceOperator"/>
        <vxe-column field="submissionAdvice.content" title="business.label.submissionAdviceContent"/>
        <vxe-column field="approvalAdvice.operator" title="business.label.approvalAdviceOperator"/>
        <vxe-column field="approvalAdvice.content" title="business.label.approvalAdviceContent"/>
        <vxe-column field="reportAdvice.operator" title="business.label.reportAdviceOperator"/>
        <vxe-column field="reportAdvice.content" title="business.label.reportAdviceContent"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import moment from 'moment/moment'
import { getOptions } from '@/utils/util'

export default {
  name: 'DisqualificationList',
  data() {
    return {
      loading: false,
      data: [],
      owners: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'owner.id': undefined,
        'no': '',
        'item.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
    })
  },
  activated() {
    this.refresh()
  },
  props: {
    orderStatus: {
      type: Number,
      default: null
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = {
        ...this.query,
        orderStatus: this.orderStatus,
        dateFilter: this.query.range.length > 0 ? { start: this.query.range[0], end: this.query.range[1] } : null
      }
      findAll('disqualificationOrderFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'owner.id': undefined,
        'no': '',
        'item.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    edit(row) {
      this.$emit('edit', row)
    }
  }
}
</script>